@if (environmentRibbonText && environmentRibbonBackground) {
  <div class="{{isAuthenticated ? 'corner-ribbon' : 'corner-ribbon-login'}} sticky {{environmentRibbonBackground}}">{{environmentRibbonText}}</div>
}
